import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';


/**
 * Factory function to create a Zustand store with sessionStorage persistence.
 * @template T
 * @param {string} name - Unique name for the storage key.
 * @param {T} initialState - Initial state of the store.
 * @returns {function(): {
 *   page: T,
 *   setPage: function(function(Partial<T>): void):void
 * }}
 */
export function createPageStore(name, initialState) {
  return create(
    persist(
      immer((set) => ({
        /** @type {T} */
        page: initialState,

        /**
         * Update page state with a partial update.
         * @param {(draft: object) => void} updater - Function to modify the page state.
         */
        setPage: (updater) => set((state) => { if (state.page) updater(state.page); }),
      })),
      {
        name: `${name}-page-storage`,
        storage: {
          getItem: (key) => {
            const storedValue = sessionStorage.getItem(key);
            return storedValue ? JSON.parse(storedValue) : null;
          },
          setItem: (key, value) => sessionStorage.setItem(key, JSON.stringify(value)),
          removeItem: (key) => sessionStorage.removeItem(key),
        },
      }
    )
  );
}
